import { ReactNode } from 'react';

export type Placement = 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';

export enum ToastType {
  Success = 'SUCCESS',
  Error = 'ERROR',
  Warning = 'WARNING',
  Info = 'INFO',
}

export interface ToastProps {
  toastContainer?: any;
  content: ReactNode | string;
  key?: string;
  placement?: Placement;
  duration?: number;
  variant: ToastType;
  action?: ActionButtonProps;
  style?: React.CSSProperties;
  onClose?: () => void;
}

export interface ToastNotificationProps {
  icon?: ReactNode | string;
  description: ReactNode | string;
  action?: ActionButtonProps;
  onClose?: () => void;
  notificationKey?: string;
}

export interface ActionButtonProps {
  label?: ReactNode;
  onClick?: () => void;
}
